var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "simple-form" }, [
    _c("div", { staticClass: "form-group" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.deprSpec.code))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.deprSpec.custAssetNatureName))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.assetNatureMap[_vm.deprSpec.assetNature]))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.deprSpec.deprMethodName))])
      ])
    ]),
    _vm._v(" "),
    _vm.deprSpec.allotAcntMethod != 0
      ? _c("div", { staticClass: "form-group" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.allotAcntMethodMap[_vm.deprSpec.allotAcntMethod])
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.deprSpec.allotAcntMethod == 2
      ? _c("div", { staticClass: "form-group" }, [
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deprSpec.transWorthRatio))])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(6),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.deprSpec.name))])
      ])
    ]),
    _vm._v(" "),
    _vm.deprSpec.deprMethodCode == "SLD" || _vm.deprSpec.deprMethodCode == "ASM"
      ? _c("div", { staticClass: "form-group" }, [
          _vm._m(7),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.deprSpec.rmnWorthRatio))])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.deprSpec.deprMethodCode == "SLD" || _vm.deprSpec.deprMethodCode == "ASM"
      ? _c("div", { staticClass: "form-group" }, [
          _vm._m(8),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.deprSpec.deprOn1stMonth ? "当月" : "次月"))
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(9),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.deprSpec.createTime))])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("规则编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("商户资产属性")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("系统资产属性")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("算法")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("转移核算方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("摊销比例(%)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("规则名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("残值率(%)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("首次计提")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建时间")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2acad996", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2acad996","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/devcDef/DeprSpecDetail.vue
// module id = 2444
// module chunks = 0